/* Royal Comfort — runtime fixes & conversion features */

/* Helper: check if a product has at least one available variant */
function rcIsInStock(product) {
  if (!product.variants || !product.variants.length) return false;
  return product.variants.some(function(v) { return v.available; });
}
window.rcIsInStock = rcIsInStock;

document.addEventListener("DOMContentLoaded", function() {

  /* ── Replace Afterpay line with Google Pay on product pages ── */
  var apLine = document.getElementById("rcd-afterpay-line");
  if (apLine) {
    var svg = '<svg class="rcd-pdp__afterpay-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>';
    apLine.innerHTML = svg + " Secure checkout with " + '<span class="rcd-pdp__afterpay-brand">Google Pay</span>' + ", Visa &amp; Mastercard";
  }

  /* Signal CSS that JS replacements are done — reveals hidden Afterpay line with correct content */
  document.body.classList.add("rc-ready");

  /* ── Global text replacements ── */
  var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
  var nd;
  var reps = [
    ["Afterpay", "Google Pay"],
    ["1 Million+ Customers", "1 Million+ Products Sold"],
    ["Trusted by over 1 million Australians", "Over 1 million products sold Australia-wide"],
    ["Trusted by Australians since 2010", "Australian owned since 2010"],
    ["Join Australians who sleep better every night", "Loved by Australians nationwide"]
  ];
  while ((nd = tw.nextNode())) {
    var t = nd.nodeValue, ch = false;
    for (var i = 0; i < reps.length; i++) {
      if (t.indexOf(reps[i][0]) !== -1) { t = t.split(reps[i][0]).join(reps[i][1]); ch = true; }
    }
    if (ch) nd.nodeValue = t;
  }

  /* ── Product page: "You May Also Like" — inside info column, directly below accordion ── */
  var pdpEl = document.querySelector(".rcd-pdp[data-product-id]");
  if (pdpEl) {
    var productId = pdpEl.getAttribute("data-product-id");
    var fmt = function(c) { return new Intl.NumberFormat("en-AU",{style:"currency",currency:"AUD"}).format(c/100); };

    /* Recs render as a full-width strip BELOW the PDP grid — keeping them out of
       the sticky buy box keeps the info column short enough to pin properly. */
    {
      var recsWrap = document.createElement("div");
      recsWrap.className = "rcd-pdp-recs rcd-pdp-recs--strip";
      recsWrap.id = "rcd-pdp-recs";
      pdpEl.parentNode.insertBefore(recsWrap, pdpEl.nextSibling);

      fetch("/recommendations/products.json?product_id=" + productId + "&limit=12&intent=related")
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.products || !data.products.length) return;
        var prods = data.products.filter(rcIsInStock).slice(0, 4);
        if (!prods.length) return;
        var html = '<div class="rcd-pdp-recs__label">You May Also Like</div>';
        html += '<div class="rcd-pdp-recs__grid">';
        prods.forEach(function(p) {
          var img = p.featured_image ? p.featured_image : (p.images && p.images.length ? p.images[0].src : "");
          if (img) img = img.replace(/(\.\w+)(\?|$)/, "_400x$1$2");
          var price = fmt(p.variants[0].price);
          var compare = p.variants[0].compare_at_price && p.variants[0].compare_at_price > p.variants[0].price ? '<span class="rcd-pdp-recs__compare">' + fmt(p.variants[0].compare_at_price) + "</span>" : "";
          var save = "";
          if (p.variants[0].compare_at_price && p.variants[0].compare_at_price > p.variants[0].price) {
            var pct = Math.round((p.variants[0].compare_at_price - p.variants[0].price) / p.variants[0].compare_at_price * 100);
            save = '<span class="rcd-pdp-recs__save">Save ' + pct + '%</span>';
          }
          html += '<a href="/products/' + p.handle + '" class="rcd-pdp-recs__card">';
          html += '<div class="rcd-pdp-recs__imgbox"><img src="' + img + '" alt="' + p.title + '" loading="lazy" class="rcd-pdp-recs__img">';
          if (save) html += '<span class="rcd-pdp-recs__badge">Sale</span>';
          html += '</div>';
          html += '<div class="rcd-pdp-recs__info">';
          html += '<div class="rcd-pdp-recs__name">' + p.title + '</div>';
          html += '<div class="rcd-pdp-recs__price">' + price + ' ' + compare + ' ' + save + '</div>';
          html += '</div></a>';
        });
        html += '</div>';
        recsWrap.innerHTML = html;
      })
      .catch(function() {});
    }

    /* ── Low stock indicator ── */
    var variantIdEl = document.getElementById("rcd-variant-id");
    if (variantIdEl) {
      var lowStockEl = document.createElement("div");
      lowStockEl.className = "rcd-pdp__low-stock";
      lowStockEl.id = "rcd-low-stock";
      lowStockEl.style.display = "none";
      lowStockEl.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> <span>Low stock \u2014 order soon</span>';
      var priceBlock = document.getElementById("rcd-price-anchor");
      if (priceBlock && priceBlock.nextSibling) {
        priceBlock.parentNode.insertBefore(lowStockEl, priceBlock.nextSibling);
      }
    }
  }

  /* ── Cart page: Remove out-of-stock cards from Customers Also Bought ── */
  var cartRecsEl = document.getElementById("rcd-cart-recs");
  if (cartRecsEl) {
    var obs = new MutationObserver(function() {
      cartRecsEl.querySelectorAll(".rcd-cart__rec-soldout").forEach(function(badge) {
        var card = badge.closest(".rcd-cart__rec-card");
        if (card) card.remove();
      });
    });
    obs.observe(cartRecsEl, { childList: true, subtree: true });
  }

  /* ── Collection page: Quick-add buttons on product cards ── */
  document.querySelectorAll(".rcd-pcard").forEach(function(card) {
    var href = card.getAttribute("href");
    if (!href) return;
    var handle = href.replace("/products/", "").split("?")[0];
    var body = card.querySelector(".rcd-pcard__body");
    if (!body) return;
    var btn = document.createElement("button");
    btn.className = "rcd-pcard__quick-add";
    btn.type = "button";
    btn.setAttribute("data-handle", handle);
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
    body.appendChild(btn);
  });

  /* Quick-add click handler */
  document.addEventListener("click", function(e) {
    var btn = e.target.closest(".rcd-pcard__quick-add");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute("data-handle");
    if (!handle) return;
    btn.disabled = true;
    btn.textContent = "Adding\u2026";
    fetch("/products/" + handle + ".js")
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(product) {
      if (!product) throw new Error("No product");
      var variant = product.variants.find(function(v) { return v.available; });
      if (!variant) { btn.textContent = "Sold Out"; btn.disabled = true; return; }
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
    })
    .then(function(r) { if (r && !r.ok) throw new Error(); return r ? r.json() : null; })
    .then(function(item) {
      if (!item) return;
      btn.innerHTML = "\u2713 Added!";
      btn.classList.add("rcd-pcard__quick-add--added");
      fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll(".rcd-hdr__cart, .rcd-hdr__cart--mobile").forEach(function(el) {
          el.textContent = "Cart (" + cart.item_count + ")";
        });
        if (typeof updateCartDrawer === "function") {
          updateCartDrawer(cart);
          var d = document.getElementById("cart-drawer");
          if (d) { d.classList.add("is-open"); d.setAttribute("aria-hidden", "false"); }
        }
      });
      setTimeout(function() {
        btn.classList.remove("rcd-pcard__quick-add--added");
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function() {
      btn.textContent = "Error";
      setTimeout(function() {
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
        btn.disabled = false;
      }, 2000);
    });
  });
});
